import styled, { css } from "styled-components";
import { PaperContainer } from "containers";
import { Button } from "components";

export const BannerContainer = styled(PaperContainer)<{ variant: "info" | "warning" }>`
	padding: 20px 24px;
	margin-top: 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	flex-wrap: wrap;

	${({ variant, theme }) =>
		variant === "info"
			? css`
					background: linear-gradient(
						135deg,
						${theme.colors.opacityYellow10} 0%,
						${theme.colors.primaryWhite} 100%
					);
				`
			: css`
					background: linear-gradient(
						135deg,
						${theme.colors.opacityRed10} 0%,
						${theme.colors.primaryWhite} 100%
					);
				`}

	@media screen and (max-width: 600px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const TextContent = styled.div`
	flex: 1;
	min-width: 200px;
`;

export const Title = styled.div`
	color: ${({ theme }) => theme.colors.primaryBlack};
	font-size: 0.875em;
	font-weight: ${({ theme }) => theme.fontWeights.boldFontWeight};
	margin-bottom: 4px;
`;

export const Description = styled.div`
	color: ${({ theme }) => theme.colors.secondaryGrey};
	font-size: 14px;

	a {
		color: #1a73e8;
		font-weight: 500;
		text-decoration: underline;

		&:hover {
			color: #1557b0;
		}
	}
`;

export const DaysCount = styled.span<{ variant: "info" | "warning" }>`
	font-weight: ${({ theme }) => theme.fontWeights.boldFontWeight};
	color: ${({ variant, theme }) =>
		variant === "info" ? theme.colors.secondaryYellow : theme.colors.secondaryRed};
`;

export const PayButton = styled(Button)`
	white-space: nowrap;
	cursor: pointer;
	flex-shrink: 0;
	height: 48px;
	border-radius: 10px;
	padding: 16px 36px;
	font-size: 0.875em;

	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;

